import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { listVirtualClasses, createVirtualClass, deleteVirtualClass, getVirtualClassMembers, removeVirtualClassMember } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// "Lớp ảo" (vd 12A9HN — lớp Hướng nghiệp gộp HS nhiều lớp) — chỉ để quản lý
// danh sách/điểm danh/xuất file. HS tự tham gia/rút ở trang của mình (tab
// "Lớp học nghề"); hồ sơ HS ở lớp gốc không bị đụng tới.
const HappySchoolVirtualClasses = () => {
  const schoolId = getActiveSchoolId();
  const [list, setList] = useState(null);
  const [selected, setSelected] = useState(null);
  const [newName, setNewName] = useState("");
  const [error, setError] = useState("");
  const [creating, setCreating] = useState(false);

  const loadList = () => listVirtualClasses(schoolId).then(setList).catch((e) => setError(e.message));
  useEffect(() => { if (schoolId) loadList(); /* eslint-disable-next-line */ }, [schoolId]);

  if (!schoolId) return <p style={{ padding: 20, color: "#6b7280" }}>Chưa chọn trường.</p>;

  const create = async () => {
    if (!newName.trim()) return;
    setCreating(true); setError("");
    try { await createVirtualClass(schoolId, newName.trim()); setNewName(""); loadList(); }
    catch (e) { setError(e.message); } finally { setCreating(false); }
  };

  const remove = async (vc) => {
    if (!window.confirm(`Xoá lớp ảo "${vc.name}"? Toàn bộ danh sách HS đã tham gia sẽ mất.`)) return;
    try { await deleteVirtualClass(schoolId, vc.id); if (selected && selected.id === vc.id) setSelected(null); loadList(); }
    catch (e) { setError(e.message); }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ margin: "0 0 4px" }}>🛠️ Lớp học nghề (lớp ảo)</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        HS từ nhiều lớp khác nhau có thể tự đăng ký tham gia (ở trang của HS, tab "Lớp học nghề") — không ảnh hưởng tới lớp học chính, không cần TKB riêng.
      </p>
      {error && <p style={{ color: "#dc2626" }}>{error}</p>}

      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <input
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder="Tên lớp ảo, vd 12A9HN"
          style={{ padding: "8px 12px", border: "1px solid #d1d5db", borderRadius: 8, minWidth: 220 }}
        />
        <button type="button" onClick={create} disabled={creating} style={btn}>
          {creating ? "Đang tạo..." : "+ Tạo lớp ảo"}
        </button>
      </div>

      {!list ? (
        <p>Đang tải...</p>
      ) : list.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Chưa có lớp ảo nào.</p>
      ) : (
        <div style={{ display: "flex", gap: 16, alignItems: "flex-start", flexWrap: "wrap" }}>
          <div style={{ width: 240, flexShrink: 0, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, padding: 8 }}>
            {list.map((vc) => (
              <div key={vc.id} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <div
                  onClick={() => setSelected(vc)}
                  style={selected && selected.id === vc.id ? navActive : nav}
                >
                  {vc.name} <span style={{ color: selected && selected.id === vc.id ? "#e0f2fe" : "#9ca3af", fontSize: 12 }}>({vc.memberCount})</span>
                </div>
                <button type="button" onClick={() => remove(vc)} title="Xoá lớp ảo" style={{ border: "none", background: "transparent", color: "#dc2626", cursor: "pointer", fontSize: 14 }}>✕</button>
              </div>
            ))}
          </div>
          <div style={{ flex: 1, minWidth: 320 }}>
            {selected ? <RosterView schoolId={schoolId} vc={selected} /> : <p style={{ color: "#6b7280" }}>Chọn 1 lớp ảo ở bên trái để xem danh sách.</p>}
          </div>
        </div>
      )}
    </div>
  );
};

function RosterView({ schoolId, vc }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");

  const load = () => getVirtualClassMembers(schoolId, vc.id).then(setRows).catch((e) => setError(e.message));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [schoolId, vc.id]);

  const remove = async (r) => {
    if (!window.confirm(`Gỡ ${r.name} khỏi lớp ảo "${vc.name}"?`)) return;
    try { await removeVirtualClassMember(schoolId, vc.id, r.studentId); load(); }
    catch (e) { setError(e.message); }
  };

  const exportExcel = () => {
    const aoa = [["STT", "Họ và tên", "Lớp gốc"], ...rows.map((r, i) => [i + 1, r.name, r.className])];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, vc.name.slice(0, 28));
    XLSX.writeFile(wb, `${vc.name}.xlsx`);
  };

  if (error) return <p style={{ color: "#dc2626" }}>{error}</p>;
  if (!rows) return <p>Đang tải...</p>;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <h3 style={{ margin: 0 }}>{vc.name} — {rows.length} học sinh</h3>
        <button type="button" onClick={exportExcel} disabled={rows.length === 0} style={btn2}>⬇ Xuất Excel</button>
      </div>
      {rows.length === 0 ? (
        <p style={{ color: "#9ca3af" }}>Chưa có học sinh nào tham gia.</p>
      ) : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead>
              <tr>
                <th style={th}>#</th>
                <th style={{ ...th, textAlign: "left" }}>Họ và tên</th>
                <th style={th}>Lớp gốc</th>
                <th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.studentId}>
                  <td style={td}>{i + 1}</td>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.name}</td>
                  <td style={td}>{r.className}</td>
                  <td style={td}>
                    <button type="button" onClick={() => remove(r)} title="Gỡ khỏi lớp ảo" style={{ border: "none", background: "transparent", color: "#dc2626", cursor: "pointer" }}>✕</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const btn = { padding: "8px 14px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13 };
const btn2 = { padding: "6px 12px", border: "1px solid #0ea5a3", borderRadius: 6, background: "#fff", color: "#0ea5a3", cursor: "pointer", fontSize: 13, fontWeight: 600 };
const nav = { flex: 1, padding: "8px 10px", borderRadius: 8, cursor: "pointer", fontSize: 14 };
const navActive = { ...nav, background: "#0ea5a3", color: "#fff", fontWeight: 700 };
const th = { border: "1px solid #e5e7eb", padding: "6px 8px", background: "#f9fafb", whiteSpace: "nowrap", textAlign: "center" };
const td = { border: "1px solid #e5e7eb", padding: "6px 8px", textAlign: "center" };

export default HappySchoolVirtualClasses;
